import Forbidden from '@package/components/ErrorPages/Forbidden/Forbidden';

export default Forbidden;
